import Abstract from '../../framework/Abstract';
import Slider from '../../framework/Slider';

import '../B1-hero/B1-hero.scss';
import './B2-homepage-hero.scss';

class B2HomepageHero extends Abstract {
	init() {
		this.setupObjectFit();

		const sliderEl = this.root.querySelector('.swiper-container');
		const { duration } = this.props;

		this.slider = new Slider(sliderEl, {
			speed: 500,
			autoplay: {
				delay: parseInt(duration, 0),
			},

			simulateTouch: false,
			preventInteractionOnTransition: true,

			effect: 'fade',
			fadeEffect: {
				crossFade: true,
			},

			pagination: {
				type: 'title-pagination',
			},
		});
	}
}

export default B2HomepageHero;
